"use client";
import React from "react";
import { useTheme } from "next-themes";
import { Sun } from "@mynaui/icons-react";
export default function ToggleTheme() {
  const { theme, setTheme } = useTheme();
  return (
    <>
      <Sun
        style={{ width: "24px", height: "24px" }}
        aria-label="Theme change"
        className="cursor-pointer"
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      />
    </>
  );
}
